import { useCallback, useContext } from 'react'
import ApplicationContext from '../context/ApplicationContext'
import SearchLocationContext from '../context/SearchLocationContext'
import { useSearchLocation } from './useSearchLocation'

const useEvents = () => {
    const [applicationData, setApplicationData] = useContext(ApplicationContext)
    const [searchLocationData, setSearchLocationData] = useContext(SearchLocationContext)
    const { handleSearch } = useSearchLocation()

    const handleViewAllEventsClick = useCallback(location => {
        if(!searchLocationData.eventsListingActiveLocationId) {
            setSearchLocationData(prevState => {
                const newState = searchLocationData.activeLocationId ? {
                    ...prevState,
                    eventsListingActiveLocationId: location.locationId,
                } : {
                    ...prevState,
                    eventsListingActiveLocationId: location.locationId,
                    highlightedLocationId: location.locationId,
                    defaultZoom: applicationData?.locationClickZoom,
                    disableRoamingRequest: true,
                    mapCenter: {
                        lat: location.latitude,
                        lng: location.longitude,
                    },
                }

                return newState
            })

            setApplicationData(prevState => {
                return {
                    ...prevState,
                    overlay: true,
                }
            })
        } else {
            setSearchLocationData(prevState => {
                const newState = searchLocationData.activeLocationId ? {
                    ...prevState,
                    eventsListingActiveLocationId: null
                } : {
                    ...prevState,
                    eventsListingActiveLocationId: null,
                    highlightedLocationId: null,
                    defaultZoom: applicationData.defaultZoom,
                }

                return newState
            })

            setApplicationData(prevState => {
                return {
                    ...prevState,
                    overlay: false,
                }
            })

            if (searchLocationData.mapCenter && !searchLocationData.activeLocationId) {
                handleSearch(searchLocationData.mapCenter, searchLocationData.address)
            }
        }
    }, [applicationData, searchLocationData])

    return {
        handleViewAllEventsClick,
    }
}

export { useEvents }
